"use client";

import React, {useState} from "react";
import Image from "next/image";
import {getDictionaries} from "@/app/dictionaries";

const ContactFormSection = ({dict}: {dict: Awaited<ReturnType<typeof getDictionaries>>}) => {
  // const {data: session} = useSession();

  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };
  //d
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch("/api/sendEmail", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(formData)
      });

      type SendEmailResponse = {success: boolean; message?: string};
      const result = (await response.json()) as SendEmailResponse;
      if (result.success) {
        setSuccess(true);
      } else {
        console.error("Email sending error:", result.message);
      }
    } catch (error) {
      console.error("Form submission error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mx-3 xl:mx-10 mb-10 mt-44" id="contactFormIdentity">
      <div className="container mx-auto py-8 px-4 md:px-8 lg:px-10">
        <div className="flex flex-col lg:flex-row justify-between items-center">
          <div className="lg:w-5/12 mb-20 lg:mb-0 ">
            <h3 className="text-4xl xs:text-5xl sm:text-6xl uppercase font-inter-display font-semibold mb-5">{dict.contactForm.title}</h3>

            <div className="border-t border-opacity-20 border-black  my-5 max-w-xs"></div>

            <figure>
              <blockquote className="italic font-light text-lg xs:text-lg sm:text-lg">&quot;{dict.contactForm.quote}&quot;</blockquote>
              <figcaption className="mt-5 flex items-center justify-between">
                <div className="flex items-center">
                  <Image width={160} height={160} className="w-16 h-16 rounded-full" src="/img/160x160/mozgii_ceo_avatar_3.jpg" alt="CEO Avatar" />
                  <div className="ml-3 ">
                    <p className="text-lg xs:text-lg sm:text-lg font-semibold uppercase">{dict.contactForm.ceoName}</p>
                    <span className="text-md xs:text-md sm:text-md text-gray-500 font-semibold ">{dict.contactForm.ceoTitle}</span>
                  </div>
                </div>
                {/* <Link href="https://outlook.office365.com/owa/calendar/MOZG@mozgii.com/bookings/s/Ck_32xSGdEShtIQK2t_Wcg2" target="_blank" rel="noopener noreferrer">
                  <button className="px-6 py-3 bg-primary uppercase text-black rounded-lg shadow-md hover:bg-green-700 text-xl xs:text-3xl sm:text-3xl font-inter-display">Free Consultation</button>
                </Link> */}
              </figcaption>
            </figure>
          </div>

          <div className="lg:w-1/2">
            <div className="bg-gr-bl p-6  shadow-md">
              <div className="mb-4 text-white ">{success ? <h3>{dict.contactForm.successMessage}</h3> : <h3 className="bg-clip-text text-white font-semibold text-xl">{dict.contactForm.formTitle}</h3>}</div>

              {!success && (
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="name" className="sr-only">
                      {dict.contactForm.fullNameLabel}
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white text-black rounded-md"
                      placeholder={dict.contactForm.fullNameLabel}
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="email" className="sr-only">
                      {dict.contactForm.emailLabel}
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white  text-black  rounded-md"
                      placeholder={dict.contactForm.emailLabel}
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="phone" className="sr-only">
                      {dict.contactForm.phoneLabel}
                    </label>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white  text-black  rounded-md"
                      placeholder={dict.contactForm.phoneLabel}
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="message" className="sr-only">
                      {dict.contactForm.messageLabel}
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-4 py-3   resize-none bg-white  text-black"
                      placeholder={dict.contactForm.messageLabel}
                      rows={4}
                      required></textarea>
                  </div>

                  <div>
                    {/* {!session?.user ? (
                      <Link href="/login" className="inline-flex items-center justify-center w-full bg-gold text-black py-3 hover:bg-opacity-80 hover:bg-gray-600 transition-all duration-300">
                        Submit
                      </Link>
                    ) : isLoading ? (
                      <button type="button" className="w-full bg-gold py-3" disabled>
                        <span className="loader spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                        Submitting...
                      </button>
                    ) : (
                      <button type="submit" className="w-full bg-gold py-3 hover:bg-opacity-80 hover:bg-gray-600  transition-all duration-300">
                        Submit
                      </button>
                    )} */}

                    {isLoading ? (
                      <button type="button" className="w-full bg-primary py-3" disabled>
                        <span className="loader spinner-border font-inter-display rounded-full text-2xl font-bold spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                        {dict.contactForm.submitting}
                      </button>
                    ) : (
                      <button type="submit" className="w-full font-inter-display rounded-full text-2xl font-bold bg-primary text-black py-3 hover:bg-opacity-80 hover:bg-gray-600  transition-all duration-300">
                        {dict.contactForm.submit}
                      </button>
                    )}
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactFormSection;
